// extracted by mini-css-extract-plugin
export default {"app_tooltip":"style_app_tooltip__eKYsa","app_tooltip__icon":"style_app_tooltip__icon__zSRaB","app_tooltip__content":"style_app_tooltip__content__CZYth"};